import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requireOfficeAccess } from '@/features/auth/utils/require-office-access';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { SETTINGS_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { InstituteTypeListPage } from '@/features/instituteTypes/pages/InstituteTypeListPage';
import { listSearchSchema } from '@/utils/listSearch';

export const Route = createFileRoute('/_auth/settings/institute-types')({
  beforeLoad: () => {
    requireOfficeAccess();
    requirePermission(SETTINGS_PERMISSIONS.INSTITUTE_TYPES_EDIT);
  },
  validateSearch: listSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Institute Types">
      <Suspense fallback={<PageLoader />}>
        <InstituteTypeListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
